import {getInfo, login, logout, unifyLogin,refreshToken} from '@/api/login';
import {getToken, removeToken, setToken} from '@/utils/auth';
import i18n from '@/i18n/index'
const user = {
    state: {
        token: getToken(),
        phone: '',
        username:"",
        id: '',
        name: '',
        avatar: '',
        roles: [],
        companyType: '',
        company: '',
        departments: [],
        info:{}
    },

    mutations: {
        SET_INFO: (state, info) => {
            state.info = info;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_USERNAME: (state, userName) => {
            state.userName = userName;
        },
        SET_USERID: (state, id) => {
            state.id = id;
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_COMPANY: (state, companyType) => {
            state.companyType = companyType;
        },
        SET_COMPANYNAME: (state, company) => {
            state.company = company;
        },
        SET_DEPARTMENTS: (state, departments) => {
            state.departments = departments;
        }
    },

    actions: {
        // 登录
        Login({commit}, userInfo) {
            console.log(userInfo, "90")
            const userName = userInfo.userName.trim();
            return new Promise((resolve, reject) => {
                unifyLogin(userName, userInfo.password,userInfo.captcha,userInfo.captchaUUID).then(response => {
                    const data = response.data;
                    setToken(data);
                    commit('SET_TOKEN', data);
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },


        // 获取用户信息
        GetInfo({commit, state}) {
            return new Promise((resolve, reject) => {
                getInfo(state.token).then(response => {
                    const data = response.data;
                    var role = data.role;
                    data.role = [];
                    // switch(role.roleLeave)
                    // {
                    //   case 1:
                    //     data.role.push("super");
                    //   case 2:
                    //     data.role.push('admin');
                    //   default :
                    //     data.role.push('user');
                    // }
                    if (null == role || null == role.roleCode) {
                        data.role.push("user");
                    } else {
                        data.role.push(role.roleCode);
                    }

                    // if (data.admin) {
                    //   data.role = ['admin'];
                    // } else {
                    //   data.role = ['edit'];
                    // }
                    commit('SET_INFO',data)
                    commit('SET_ROLES', data.role);
                    commit('SET_NAME', data.name);
                    commit('SET_USERNAME', data.userName);
                    commit('SET_USERID', data.id);
                    //  commit('SET_AVATAR', data.avatar);
                    commit('SET_COMPANY', data.company.id);
                    commit('SET_COMPANYNAME', data.company.name);
                    commit('SET_DEPARTMENTS', data.departments);
                    if (data.company.type == 1) {
                        commit('deptOrCollegeName', i18n.t('user.name12'));
                        commit('deptOrCollegeTip', i18n.t('user.name13'));
                        commit('deptOrCollegeNo', i18n.t('department.name10'));
                        commit('deptOrCollegeNoTip', i18n.t('department.name11'));
                        commit('deptOrCollege', i18n.t('department.name12'));
                    } else {
                        commit('deptOrCollegeName', i18n.t('department.name13'));
                        commit('deptOrCollegeTip', i18n.t('department.name14'));
                        commit('deptOrCollegeNo', i18n.t('department.name15'));
                        commit('deptOrCollegeNoTip', i18n.t('department.name16'));
                        commit('deptOrCollege', i18n.t('department.name17'));
                    }

                    resolve(response);
                }).catch(error => {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    removeToken();
                    reject(error);
                });
            });
        },

        // 登出
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    removeToken();
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 前端 登出
        FedLogOut({commit}) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '');
                removeToken();
                resolve();
            });
        },
        // 获取新token
        refreshToken({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                refreshToken().then(response => {
                   console.log(response.data,"获取新token");
                    const data = response.data;
                    setToken(data);
                    commit('SET_TOKEN', data);
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },
        startTokenRefresh({ dispatch }){
            setInterval(() => {
                dispatch('refreshToken').catch(error => {
                    console.error('Failed to refresh token:', error);
                    // 可能需要处理token刷新失败的情况，比如清除token并让用户重新登录
                });
            }, 3600000);// 3600000毫秒 = 1小时
        }
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js